import React from "react";

import useGenerateReportForm from "./generateReport/hooks/useGenerateReportForm";

import GenerateReport from "./generateReport/index";


export default function GenerateReportWrapper(params) {
	const {
		api,
		clienteInfo,
		allHostsCliente,
		getInterface,
		setSnackbar,
		theme,
		reportToEdit,
	} = params;

	// ==========================================
	// Estado centralizado criado UMA única vez aqui
	// ==========================================
	const formState = useGenerateReportForm({
		api,
		clienteInfo,
		allHostsCliente,
		getInterface,
		setSnackbar,
		reportToEdit,
	});

	return (
		<GenerateReport
			{...params}
			formState={formState}
		/>
	);
}

